import {Component, HostListener, inject, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { faTriangleExclamation, faXmark, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import {RoleService} from "../../../data-access/role.service";
import {SubjectsModel} from "../../../data-access/subjects.model";
import {UnitsModel} from "../../../data-access/units.model";
import {RoleDetail} from "../userRolesList/userRolesList.component";
import {UserManagementService} from "../../../data-access/user-management.service";
import {ComponentCanDeactivate} from "../../../../exam/utils/pending-changes.guard";
import {Observable, of, switchMap} from "rxjs";
import {
  ConfirmDialogComponent,
  DIALOG_ACTION_STYLE
} from "../../../../shared/ui/confirm-dialog/confirm-dialog.component";
import {Dialog} from "@angular/cdk/dialog";
import {Location} from "@angular/common";
import {FormControl, FormGroup} from "@angular/forms";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
import { OrganizationsModel } from 'src/app/admin/data-access/organizations.model';
interface RoleTempInterface {
  name: string
  role_id: string
  subjects?: SubjectsModel[]
  units?: UnitsModel[]
  organizations?: OrganizationsModel[]
}
@Component({
    selector: 'addNewUser',
    templateUrl: './addNewUser.html',
    styleUrls: ['../userRoleAddEdit/userRoleAddEdit.css'],
    standalone: false
})
export class AddNewUserComponent implements ComponentCanDeactivate, OnInit {

  firstNameValidation = false;
  lastNameValidation = false;
  usernameValidation = false;
  emailValidation = false;
  roleValidation = false;
  openExitDialog = false;
  openAssignDialog = false;
  firstName = '';
  lastName = '';
  username = '';
  email = '';
  ruid = ''
  school_code = ''
  admit_code = ''
  netID = '';
  faTriangleExclamation = faTriangleExclamation;
  faXmark = faXmark;
  faChevronRight = faChevronRight;
  roleList: RoleTempInterface[] = [];
  addedRoleList: RoleTempInterface[] = [];
  assignRoleDetails: RoleDetail | null = null;
  subjectList: SubjectsModel[] = [];
  organizationList: OrganizationsModel[] = [];
  addedSubjectList: SubjectsModel[] = [];
  unitList: UnitsModel[] = [];
  addedUnitList: UnitsModel[] = [];
  addedOrganizationList: OrganizationsModel[] = []
  saveDialog = false;
  errorMessage = "";
  showErrorDialog = false;
  constructor(
    private router: Router,
    private roleService: RoleService,
    private userService: UserManagementService
  ) {}
  dialog = inject(Dialog);
  _location = inject(Location)
  userForm = new FormGroup({
    firstName: new FormControl(null),
    lastName: new FormControl(null),
    netID: new FormControl(null),
    email: new FormControl(null),
    ruid: new FormControl(null),
    admit_code: new FormControl(null),
    school_code: new FormControl(null),
  })
  createClick = false
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'User Management',
    route: 'dashboard/UserManagement'
  }]

  ngOnInit() {
    this.roleService.listAllUserRoles().subscribe((response) => {
      if(response.success)
        for(let role of response.items)
          this.roleList.push({name: role.name, role_id: role.role_id})
    })
  }

  userManagementMenu() {
    this.router.navigate(['dashboard/UserManagement']);
  }

  createUser() {
    const regEmail = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    let tempRoleID = "";
    let tempSubjectID = "";
    let tempUnitID = "";
    let tempOrganizationID = "";
    this.createClick = true
    if(this.addedRoleList.length !== 0) {
      tempRoleID = this.addedRoleList[0].role_id;
      if (this.addedRoleList[0].subjects != null && this.addedRoleList[0].subjects.length !== 0)
        tempSubjectID = this.addedRoleList[0].subjects[0].subject_id;
      if (this.addedRoleList[0].units != null && this.addedRoleList[0].units.length !== 0)
        tempUnitID = this.addedRoleList[0].units[0].unit_id;
      if (this.addedRoleList[0].organizations != null && this.addedRoleList[0].organizations.length !== 0)
        tempOrganizationID = this.addedRoleList[0].organizations[0].organization_id;
    }
    if(this.firstName === "")
      this.firstNameValidation = true;
    else
      this.firstNameValidation = false;
    if(this.lastName === "")
      this.lastNameValidation = true;
    else
      this.lastNameValidation = false;
    if(this.email === "" || !regEmail.test(this.email))
      this.emailValidation = true;
    else
      this.emailValidation = false;
    if(this.username === "")
      this.usernameValidation = true;
    else
      this.usernameValidation = false;
    if(this.firstName !== "" && this.lastName !== "" && this.email !== "" && this.username !== "" && regEmail.test(this.email))
      this.userService.createUser(this.firstName, this.lastName, this.email, this.username, this.ruid, this.school_code,
        this.admit_code, tempRoleID, tempSubjectID, tempUnitID, tempOrganizationID).subscribe((response) => {
        if(response.success) {
          this.saveDialog = true;
          setTimeout(() => {
            this.saveDialog = false;
            this.router.navigate(['dashboard/UserManagement'])
          }, 4000)
        } else {
          this.showErrorDialog = true
          this.errorMessage = response.msg
        }
      })
  }

  removeItemFromList(item: any, list: any[]) {
    return list.filter(e => e.name !== item.name);
  }

  openAssignClick(role_id: string, subjects?: SubjectsModel[], units?: UnitsModel[], organizations?: OrganizationsModel[]) {
    this.roleService.getRoleDetail(role_id.toString()).subscribe((response) => {
      if(response.success) {
        this.assignRoleDetails = {
          name: response.result.name,
          role_id: response.result.role_id,
          organizations: response.result.organizations,
          subjects: response.result.subjects,
          units: response.result.units
        }
        this.subjectList = response.result.subjects;
        this.unitList = response.result.units;
        this.organizationList = response.result.organizations;
      }
    })
    if(subjects != null)
      this.addedSubjectList = subjects;
    if(units != null)
      this.addedUnitList = units;
    if(organizations != null)
      this.addedOrganizationList = organizations;
    this.openAssignDialog = true;
  }

  saveOptionalDetails(role_id?: string) {
    if(role_id != null)
      for(let i = 0; i < this.addedRoleList.length; i++) {
        if(this.addedRoleList[i].role_id === role_id) {
          this.addedRoleList[i].organizations = this.addedOrganizationList;
          this.addedRoleList[i].units = this.addedUnitList;
          this.addedRoleList[i].subjects = this.addedSubjectList;
        }
      }
    this.openAssignDialog = false;
  }

  canDeactivate(): Observable<boolean> {
    if (this.userForm.dirty && !this.createClick) {
      const dialogRef = this.dialog.open<string>(ConfirmDialogComponent, {
        data: {
          title: 'Sure you want to cancel?',
          message: 'Are you sure you want to cancel creating this user?',
          button_actions: [
            {
              label: 'Yes, Cancel',
              style: DIALOG_ACTION_STYLE.PRIMARY,
              action: () => 'Confirm',
            },
            {
              label: "Don't Cancel",
              style: DIALOG_ACTION_STYLE.DEFAULT,
              action: () => 'Cancel',
            },
          ],
        },
      });

      return dialogRef.closed.pipe(
        switchMap((result) => {
          if (result === 'Confirm') {
            return of(true);
          }
          return of(false);
        })
      );
    }
    return of(true)
  }

  @HostListener('window:beforeunload')
  unloadHandler() {
    if (this.userForm.dirty) {
      return false;
    }
    return true;
  }
}
